import { Field } from 'formik';
import { FormikRadioGroup } from '@flexinet/ui-components';
import { UserStatus } from '../../types';

export const FilterFormComponent = () => {
    const userStatusOptions = [
        { value: '', label: 'All Statuses' },
        { value: UserStatus.CONFIRMED, label: 'Confirmed' },
        { value: UserStatus.UNCONFIRMED, label: 'Unconfirmed' },
        { value: UserStatus.EXTERNAL_PROVIDER, label: 'External Provider' },
        { value: UserStatus.RESET_REQUIRED, label: 'Reset Required' },
        { value: UserStatus.FORCE_CHANGE_PASSWORD, label: 'Force Change Password' },
    ];

    return (
        <Field
            name="status"
            label="User Status"
            data={userStatusOptions}
            component={FormikRadioGroup}
            my="md"
        />
    );
};
